/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Subtitle_Export_Event_OverlapInputs */



/**
* | output |
* | --- |
* | "Event {index} overlaps with the previous event. Would you like to ABORT your export?" |
*
* @param {Subtitle_Export_Event_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_event_overlap = /** @type {((inputs: Subtitle_Export_Event_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Event_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'événement ${i?.index} chevauche l'événement précédent.

Souhaitez-vous annuler l'exportation ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignis ${i?.index} überschneidet sich mit dem vorherigen Ereignis.
Möchten Sie Ihren Export abbrechen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'evento ${i?.index} si sovrappone all'evento precedente.
Vuoi ANNULLARE l'esportazione?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} перекрывается с предыдущим событием.
Вы хотите ОТМЕНИТЬ экспорт?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El evento ${i?.index} se superpone con el evento anterior.
¿Desea cancelar la exportación?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} 与上一个事件重叠。

是否要中止导出？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} は前のイベントと重複しています。
エクスポートを中止しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.index} पिछले इवेंट के साथ ओवरलैप हो रहा है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O evento ${i?.index} se sobrepõe ao evento anterior.
Deseja CANCELAR a exportação?`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} overlaps with the previous event.
 Would you like to ABORT your export?`)
});